<template>
 <div>
 <table style="position: absolute;" width="100%"  :height="this.windowSize.height-8"  :max-height="this.windowSize.height-8" >
<tr max-height="48px" height="48px"  >
      
<ContenidoBase 
  :titulo="'Reporte Ventas por ARS y Productos Vendidos'"
  :descripcion="'Imprime las Ventas de las ARS y Productos Vendidos'"
   :EstadoBtn="EstadoBtn"
   @abrirBarraTablaDinamica="abrirTabla"
   @MethodNuevo="newwnuevo"
   @MethodGuardar="save"
   @MethodEliminar="remove"
   @MethodAnular="anular"
   @MethodImprimir="imprimirList"
   
/>
    </tr>

  
    <tr>
<!-- BarraPrimaria --------------------------------------------------------------------------------->
      <td width="109" :max-height="this.windowSize.height-96" v-show="BarraTablaDinamicaAprir">

         <div class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px'  }">
        
        <v-tooltip left>
          <template v-slot:activator="{ on }">
              <center>
              <v-btn-toggle>
                <v-btn
                  small
                  color="yellow accent-4"
                  @click.prevent="actualiza_tb_ver"
                >
                  <i style="font-size: 25px;" class="fa fa-eye"> </i> ver</v-btn
                >
                <v-btn
                  small
                  dark
                  color="deep-purple accent-2"
                  @click.prevent="notifi('Seguro que desea nuevo', 'n')"
                >
                  <i style="font-size: 25px;" class="fa fa-print"> </i>
                  Listado</v-btn
                >
              </v-btn-toggle>
            </center>
            <!-- <BarraBusqueda2
              :url="
                $hostname + $hName + '/services/tipocliente/findalltipoclientes'
              "
              :nombre="'Tipo de Clientes'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitReportesVentasARS'"
              :SeachNombre="'Búsqueda por descripcion '"
              :slotlist="slotlist"
            /> -->
          </template>
        </v-tooltip>

      </div>
      </td>
<!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
<!-- contenido central ------------------------------------------------------------------------------ -->
      <td :max-height="this.windowSize.height-96" >
        <v-app id="inspire" class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' }">
 
<!-- Formulario-Ventas por ARS-->
 <v-container >
  <v-card color="grey lighten-3">

<v-toolbar
        flat
        color="#BDBDBD"
        dense
        style="border: 1px solid #000000;"
      >
        
  
 <v-avatar tile  size="45"  >
      <img
        src="@/assets/iconos_micromarket/custom-reports.png"
        alt="Reporte"
      >
    </v-avatar>

    
<span class="font-weight-light" style="font-size: 20px;" > Ventas Por ARS </span >

  <!-- <v-toolbar-title    class="font-weight-light"> Reporte Producción de boletos por unidades</v-toolbar-title > -->
   <!-- style="color:white;" -->
    <!-- <i class=""> </i> -->

        <!-- <v-spacer></v-spacer> -->
        <!-- <v-btn
          color="grey darken-4"
          fab
          small
          @click="cerrarmodalcuenta"
        >
         <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
        </v-btn> -->
      </v-toolbar>
           
<hr>

  <v-container style="border: 1px solid #000000;">
  <v-form ref="form" @submit.prevent=""  v-model="valid" lazy-validation>
              <v-row>
<!-- columna 1 -->
<v-col cols="12" md="6" sm="6">
  <!-- -----------------------------  desde  -->
<v-text-field
        dense
        outlined
        type="date"  
        label="Desde:"
         :rules="[$rules.required]"
        v-model="VentasARS.desde"
        @blur="BlurDesde"

        >
                <template v-slot:prepend>
                  <i style="font-size: 20px;" class="fa fa-calendar"></i>
                </template>

</v-text-field>

<!-------------------------------------------------- Ars -->
                        <v-combobox autocomplete="off" dense outlined label="ARS" :items="RArs"
                          item-text="nombre" v-model="VentasARS.ars"
                          @blur="SelctCbArs" @focus="cargarArs">
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-shield"></i>
                          </template>
                        </v-combobox>

</v-col>
<!-- fn columna 1 -->


<!-- columna 2 -->
<v-col cols="12" md="6" sm="6">
<!-- -----------------------------  Hasta  -->
<v-text-field
        dense
        outlined
        type="date" 
         :rules="[$rules.required]" 
        label="Hasta:"
        v-model="VentasARS.hasta"
        @blur="BlurHasta"

        >
                <template v-slot:prepend>
                  <i style="font-size: 20px;" class="fa fa-calendar"></i>
                </template>

</v-text-field>

<v-combobox hide-details autocomplete="off" dense outlined label="Sucursal:" :items="ListaSucursales"
                          item-text="descripcion"  v-model="VentasARS.sucursal"
                          @focus="CargarRSucursal" @blur="SelctCbSucursal">
                          <template v-slot:prepend>
                            <i style="font-size: 20px;" class="fa fa-users"></i>
                          </template>
</v-combobox>
</v-col>
<!-- fn columna 2 -->


              
              </v-row>






            </v-form>
       </v-container>

<hr>
<ModalReporteFiltros
 ref="ModRepFilt"
@DataReporteBasico="DDataReporteBasico"
:Datos="VentasARS"
/>

  </v-card>
 </v-container>
<!-- fn Formulario-Ventas por ARS-->
        </v-app> 
      </td>
<!-- fn contenido central ------------------------------------------------------------------------------------->
<!-- BarraSecundaria ------------------------------------------------------------------------------------------>
      <td width="109" :max-height="this.windowSize.height-96" v-show="BarraSecundariaAprir" >

 <div  class="overflow-y-auto " v-bind:style="{  'max-height':this.windowSize.height-96+ 'px' , 'max-width': '325px', 'width': '325px' }">
        
<!--         
        <BarraBusqueda2
              :url="$hostname + $hName + '/services/caja/findAll'"
              :nombre="'Cajas'"
              :headers="headers"
              :slotname="'item.descripcion'"
              :emitnombre="'emitCaja'"
              :slotlist="slotlist"
              :SeachNombre="'Búsqueda por descripción caja'"
            /> -->
</div>

      </td>
<!-- fn BarraSecundaria --------------------------------------------------------------------------------------->



    </tr>
  </table>
<!-- Modales -------------------------------------------------------------------------------------------------->
  <!-- ------------------------------------------------------ tb-data-->
    <v-dialog
      label="myAlert"
      v-model="acti_tb_data"
      persistent
      max-width="100%"
      max-height="100%"
      transition="fab-transition"
    >
      <v-card>
        <v-toolbar flat color="#BDBDBD">
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"></i>
          <v-toolbar-title class="font-weight-light"> REPORTE </v-toolbar-title>
          <i style="font-size: 20px;" class="fa fa-file-pdf-o"> </i>

          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-4"
            fab
            small
            @click="acti_tb_data = !acti_tb_data"
          >
            <i style="font-size: 20px; color:#dd4b39;" class="fa fa-close"></i>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-card>
            <v-card-title>
              <v-text-field
                v-model="search"
                @keyup="filtro"
                label="Buscar"
                single-line
                hide-details
              >
                <template v-slot:prepend-inner>
                  <i style="font-size: 35px;" class="fa fa-search"></i>
                </template>
              </v-text-field>
            </v-card-title>

            <v-data-table
              :headers="slotHtabla"
              dense
              :items="list"
              :search="search"
              @click:row="datostabla"
            >
              <template v-slot:item.porciento="props">
                <span>{{ currencyFormatter(props.item.porciento) }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------ Elim_notif-->
    <v-dialog
      label="myAlert"
      v-model="Elim_notif.estado"
      persistent
      max-width="350"
      transition="fab-transition"
    >
      <template justify="center" v-slot:activator="{ on }"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i style="font-size: 28px;" class="fa fa-warning"></i>
            CONFIRMACION
            <i style="font-size: 28px;" class="fa fa-warning"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ Elim_notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn
            @click.prevent="
              eliminar(), (Elim_notif.estado = !Elim_notif.estado)
            "
            small
          >
            <i style="font-size: 20px;" class="fa fa-check"></i> Si
          </v-btn>

          <v-btn @click.prevent="Elim_notif.estado = !Elim_notif.estado" small>
            <i style="font-size: 20px;" class="fa fa-ban"></i> No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn Elim_notif -->

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      style="margin-top: 20%;"
      :vertical="true"
      :timeout="120000"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

<!-- fn Modales ----------------------------------------------------------------------------------------------->


  </div>
</template>

<script>
import { EventBus } from "../../event-bus";
import BarraBusqueda2 from "../../components/BarraBusquedaDinam";
import ContenidoBase from "../../components/ContenidoBase";
import ModalReporteFiltros from "../../components/ModalReporteFiltros";
import { currencyFormatter,
  FormatoFecha,
  HoraFormatter,
  HoraFormatter2,
  RedondeoValor,
  RedondeoBasico,
  RedondeoValorCantRed,
  fechaNueva,
  getParamFecha
} from "@/js/Funciones.js";
export default {
  components: {
    BarraBusqueda2,
    ContenidoBase,
    ModalReporteFiltros

  },
  created() {
    var json = { 
      titulo: "Reporte Ventas por ARS y Productos Vendidos",
      descripcion: "Imprime las Ventas de las ARS y Productos Vendidos",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: false,
      imprimir: false,
      accion: [ 

        "ReportesVentasARSNew",
        "ReportesVentasARSSave",
        "ReportesVentasARSRemove",
        "ReportesVentasARSAnular",
        "ReportesVentasARSPrintList"
      ], 
    };
    EventBus.$emit("anularBotonesAccion", json);
  },
  // mounted-carga de inicio
  mounted() {
    EventBus.$on("abrirMenuizquierdo", this.abrirTabla);
    // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
    EventBus.$on("ReportesVentasARSNew", this.new);
    EventBus.$on("ReportesVentasARSSave", this.save);
    EventBus.$on("ReportesVentasARSRemove", this.remove);
    EventBus.$on("ReportesVentasARSAnular", this.remove);
    EventBus.$on("ReportesVentasARSPrintList", this.imprimirList);
    EventBus.$on("emitReportesVentasARS", this.datostabla);
   

    EventBus.$on("onResize", this.onResize);
    this.$refs.ModRepFilt.CrearObjecto=this.validarObjecto;

  },
// fn mounted-carga de inicio
  data:()=>  ({


      Rpropietario:[],
      RCaja:[],
      ListaSucursales:[],
      RArs:[],


      ListaTiposClientes: [],
      windowSize:{width:"auto", height:"auto"},
      VentasARS: {

        nombre:'REPORTE VENTAS POR ARS Y PRODUCTOS VENDIDOS',
        UrlImprimir: '/reportes-pv/ImprimirVentasARSProductosVendidos', 
        UrlExel: '/reportes-pv/ExcelVentasARSProductosVendidos', 
        UrlCorreo: '/reportes-pv/CorreoVentasARSProductosVendidos', 
        desde: fechaNueva(),
        hasta:fechaNueva(),
        sucursal:null,
        ars:null
       
        //fechaCreacion: new,
      //  fechaModificacion: "", 
      },
      EstadoBtn:{ 
        BarraTablaDinamicaAprir:false,
        nuevo:false,
        guardar:false,
        eliminar:false,
        anular:false,
        imprimir:false,
        vercuenta:false,
        guardartemporal:false,
        restaurartemporal:false,
        importarDato:false,
        cargarProducto:false,
        ImprimirproductoInv:false,
        },


     
      text: "",
      valid: true,
     BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,

      headers: [{ text: "Tipo Clientes", value: "descripcion" }],

      slotlist: [
        { dt0: "codigo", dt1: null, dt2: null, dt3: 1, dt4: "Código:" },
        {
          dt0: "descripcion",
          dt1: null,
          dt2: null,
          dt3: 1,
          dt4: "Descripcion:"
        },
        { dt0: "activo", dt1: null, dt2: null, dt3: 0.1, dt4: "Desactivo" },
      ],

      slotHtabla: [
        { text: "Código", value: "codigo" },
        { text: "Descripcion", value: "descripcion" }
      ],

      list: [],
      search: "",
      acti_tb_data: false,
      Elim_notif: {
        estado: false,
        nombre: "¿Seguro que desea anular este registro?"
      },

      aalert: {
        estado: false,
        color: null
      },
    
    }),


  //   destroyed() {
  //     location.reload();
  //   },
  methods: {
  currencyFormatter,
  FormatoFecha,
  HoraFormatter,
  HoraFormatter2,
  RedondeoValor,
  RedondeoBasico,
  RedondeoValorCantRed,
  fechaNueva,
  getParamFecha,
onResize(e){

console.log("imprii ")

console.log(e)
this.windowSize=e


},

    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir;

    },
    
    datostabla(e) {

      this.VentasARS = e;
      this.acti_tb_data=false
    },
    save() {  },
    remove() { },
    eliminar() {},
    anular() {},
    imprimirList() {},
    // Retorna los datos del componente ModalReporteFiltros
    DDataReporteBasico(){},

validarObjecto(){
// this.VentasARS.fechaini=new Date(this.VentasARS.desde)
 //this.VentasARS.fechafin=new Date(this.VentasARS.hasta)

//var params = new Date(this.VentasARS.desde).toISOString().substr(0, 10);
//var params = new Date(this.VentasARS.desde).toISOString().substr(0, 10);


 if(!this.$refs.form.validate()) {
       this.alerta("Debe seleccionar los campos en rojo","error");
       this.$refs.ModRepFilt.detener = true;
       return 
      }else{
        this.$refs.ModRepFilt.detener = false;
      }
        var condicion = ``;
        var where = ``;
        var subqrywhere = ``;
          /*var fecdesde=this.getParamFecha(this.VentasARS.desde)
          var fechasta=this.getParamFecha(this.VentasARS.hasta)*/
        // new Date(this.VentasARS.desde).toISOString().substr(0, 10)

          var CONDUCION=`Desde: ${this.FormatoFecha(this.VentasARS.desde)} \t Hasta: ${this.FormatoFecha(this.VentasARS.hasta)} `
          var fecdesde=this.VentasARS.desde
          var fechasta=this.VentasARS.hasta
   
        var subqrywhere = ` subqry.activada=true and subqry.fecha >= '${fecdesde}' and subqry.fecha  <='${fechasta}' `
        var where = ` pr.borrado=false and fv.activada=true and fv.fecha >= '${fecdesde}' and fv.fecha  <='${fechasta}'  `

        if (this.VentasARS.ars != null) {
          where += ` and ar.codigo= ${this.VentasARS.ars.codigo}`;
          subqrywhere += ` and subqry.codars= ${this.VentasARS.ars.codigo}`;
          CONDUCION+=`\t ARS: ${this.VentasARS.ars.nombre.trim()} `
        }

        if (this.VentasARS.sucursal != null) {
          where+= ` and fv.sucursal = ${this.VentasARS.sucursal.codigo}`;
          subqrywhere += ` and subqry.codsuc= ${this.VentasARS.sucursal.codigo}`;
          CONDUCION+=`\t SUCURSAL: ${this.VentasARS.sucursal.descripcion.trim()} `
        }
        subqrywhere+=` order by subqry.codars asc,subqry.fecha desc`

         this.VentasARS.where = where
         this.VentasARS.subqrywhere = subqrywhere
         this.VentasARS.condicion = CONDUCION

},


    newwnuevo() {
      (this.VentasARS = {
        activo: true,
        borrado: false,
        codigo: 0,
        descripcion: "",
        descripcionOriginal: "",
        fechaCreacion: "",
        fechaModificacion: "",
        usuarioCreacion: "",
        usuarioModificacion: ""
      }),
        EventBus.$emit("actualizaBarraBusqueda2");
    },


  // Llamar a la API y obtener los datos de la API.
    CargarRSucursal() {

      var headers = this.$store.getters.GetheadersAxios
      this.$axios.get(this.$hostname + this.$hName + "/sucursal/findallActivos/", { headers: headers })
        .then(res => (this.ListaSucursales = res.data))
        .catch(error => console.log(error));
    },
   // Comprobando si el valor de la selección es nulo o indefinido.
    SelctCbSucursal() {

var _this = this
      setTimeout(function() {
        if (_this.VentasARS.sucursal == null) {
          _this.VentasARS.sucursal = ""
        }

        if (!_this.VentasARS.sucursal.hasOwnProperty("codigo")) {
          _this.VentasARS.sucursal = ""
          _this.VentasARS.sucursal = null
          //  _this.alerta("Seleccione un cliente", "error");
          return
        }
      }, 300)

    },

 cargarArs() {
      this.$axios.get(this.$hostname + this.$hName + '/ars/findallactivos', { headers: this.$store.getters.GetheadersAxios })
        .then(res => (this.RArs = res.data))
    },


    SelctCbArs() {
      var _this = this;
      setTimeout(function () {
        if (_this.VentasARS.ars == null) {
          _this.VentasARS.ars = "";
        }

        if (!_this.VentasARS.ars.hasOwnProperty('codigo')) {
          _this.VentasARS.ars = "";
          _this.VentasARS.ars = null;
          return;
        }
      }, 300);

    },



// Establecer la fecha a la fecha de hoy si el usuario no ingresa una fecha.
BlurDesde(){

if(this.VentasARS.desde.toString().length==0){
  this.VentasARS.desde=this.fechaNueva()
}

 },

// Establecer la fecha a la fecha de hoy si el usuario no ingresa una fecha.
 BlurHasta(){

if(this.VentasARS.hasta.toString().length==0){
  this.VentasARS.hasta=this.fechaNueva()
}

 },





    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
          (this.aalert.color = "success"),
          (this.aalert.nombre = e);

        this.newwnuevo();
      }

      if (l == "error") {
        (this.aalert.estado = true),
          (this.aalert.color = "error"),
          (this.aalert.nombre = e);

        this.ejecucion = false;
      }
    },




    actualiza_tb_ver() {
      this.acti_tb_data = !this.acti_tb_data;
      this.filtro();
    },

    async filtro() {

    }
  }
};
</script>

<style></style>
